import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
import AppModule, { IAppState } from "./modules/app.module"
import ReportingModule, { IReportModuleState } from "./modules/reporting.module"

export interface IRootState {
  app: IAppState
  reporting: IReportModuleState
}

Vue.use(Vuex)

const vuexLocal = new VuexPersistence<IRootState>({
  storage: window.localStorage,
})

const store = new Vuex.Store<IRootState>({
  modules: { app: AppModule, reporting: ReportingModule },
  plugins: [vuexLocal.plugin],
})

export default store
